import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.91669 2.91406H5.58335C4.64993 2.91406 4.18322 2.91406 3.8267 3.09572C3.5131 3.25551 3.25813 3.51047 3.09834 3.82408C2.91669 4.1806 2.91669 4.64731 2.91669 5.58073V14.4141C2.91669 15.3475 2.91669 15.8142 3.09834 16.1707C3.25813 16.4843 3.5131 16.7393 3.8267 16.8991C4.18322 17.0807 4.64993 17.0807 5.58335 17.0807H14.4167C15.3501 17.0807 15.8168 17.0807 16.1733 16.8991C16.4869 16.7393 16.7419 16.4843 16.9017 16.1707C17.0834 15.8142 17.0834 15.3475 17.0834 14.4141V12.0807M12.0834 2.91406H17.0834M17.0834 2.91406V7.91406M17.0834 2.91406L9.58335 10.4141",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }